import DOMPurify from 'dompurify';

/**
 * Sanitizes an HTML string through DOMPurify before it reaches the DOM.
 * Use this for every v-html binding to prevent XSS from user-generated content.
 *
 * @example
 * // In a Vue template:
 * // <!-- eslint-disable-next-line vue/no-v-html -->
 * // <div v-html="sanitize(userContent)"></div>
 */
export const sanitize = (html: string): string =>
  DOMPurify.sanitize(html ?? '', {
    USE_PROFILES: { html: true },
  });
